const permissions = require('./permissions');
const officeUserRoles = require('./officeUserRoles');

const bitPermissionsSum = (permissionsArray) => {
    return permissionsArray.reduce((permissionsSum, permission) => permissionsSum + permission.bitPermissions, 0);
};
/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    superadmin: {
        roleName: officeUserRoles.SUPERADMIN,
        bitPermissions: bitPermissionsSum([
            permissions.MANAGE_LECTURE,
            permissions.SEND_MESSAGE_TO_LECTURE_ATTENDEES,
            permissions.MANAGE_CLIENT_ORDER,
            permissions.READ_OFFICE_MONEY,
            permissions.READ_OFFICE_CLIENTS,
            permissions.WRITE_OFFICE_CLIENTS,
            permissions.READ_OFFICE_CLIENT_ORDERS,
            permissions.READ_OFFICE_SETTINGS,
            permissions.WRITE_SUPERADMIN_OFFICE_SETTINGS,
            permissions.WRITE_EXTENDED_OFFICE_SETTINGS,
            permissions.READ_TARIFF_INFO,
            permissions.WRITE_ORGANISATION_TARIFF_INFO,
        ]),
    },
    // user with extended access
    manager: {
        roleName: officeUserRoles.MANAGER,
        bitPermissions: bitPermissionsSum([
            permissions.MANAGE_LECTURE,
            permissions.SEND_MESSAGE_TO_LECTURE_ATTENDEES,
            permissions.MANAGE_CLIENT_ORDER,
            permissions.READ_OFFICE_CLIENTS,
            permissions.WRITE_OFFICE_CLIENTS,
            permissions.READ_OFFICE_CLIENT_ORDERS,
            permissions.READ_OFFICE_SETTINGS,
            permissions.WRITE_EXTENDED_OFFICE_SETTINGS,
        ]),
    },
    // BFL = "bezny Franta lektor"
    official: {
        roleName: officeUserRoles.OFFICIAL,
        bitPermissions: bitPermissionsSum([
            permissions.SEND_MESSAGE_TO_LECTURE_ATTENDEES,
            permissions.MANAGE_CLIENT_ORDER,
        ]),
    },
};
